"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnClickOutside = exports.default = void 0;
var _react = require("react");
var useOnClickOutside = exports.useOnClickOutside = function useOnClickOutside(_ref) {
  var ref = _ref.ref,
    handleClickOutside = _ref.handleClickOutside,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? true : _ref$show;
  var handleMouseDown = function handleMouseDown(e) {
    var _ref$current$contains, _ref$current;
    if (!ref.current || (_ref$current$contains = (_ref$current = ref.current).contains) !== null && _ref$current$contains !== void 0 && _ref$current$contains.call(_ref$current, e.target)) {
      return;
    }
    if (typeof handleClickOutside === 'function') {
      handleClickOutside(e);
    }
  };
  (0, _react.useEffect)(function () {
    if (show) {
      document.addEventListener('mousedown', handleMouseDown);
    } else {
      document.removeEventListener('mousedown', handleMouseDown);
    }
    return function () {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [show]);
};
var _default = exports.default = useOnClickOutside;